// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eb_0","col":"styles_col__3yoVY","actions":"styles_actions__7p_Uq","conflict":"styles_conflict__3KoKc"};